import { Box } from '@moonpig/launchpad-components'
import { styled } from '@moonpig/launchpad-utils'
import { system as s } from '@moonpig/launchpad-system'

export const CarouselItem = styled(Box)`
  ${s({
    display: 'flex',
    alignItems: 'flex-end',
    py: { md: 5 },
    height: '100%',
  })}
`
